import React, { ComponentProps, FC } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaSync } from 'react-icons/fa';

type Props = ComponentProps<typeof Button>;

export const ButtonRefresh: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Button
      {...props}
      style={{ width: '160px' }}
      className="ms-2"
      onClick={props.onClick}
    >
      <FaSync className="mb-1" /> {t('Refresh')}
    </Button>
  );
};
